export default "__VITE_ASSET__BdL8p4pM__"